import React from 'react';
import { Link } from 'react-router-dom';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <h3 className="modern-slavery-title">One world, one market, one objective:</h3>
        <h2 className="subtitle">Identify and work to eradicate modern slavery in our supply chain</h2>
        <p>
            As a global retailer and manufacturer, we recognise that a major step in our commitment to the eradication
            of modern slavery is to identify those involved in our manufacturing supply chain and the opportunities this
            identification brings to effect positive change to thousands of people worldwide.
        </p>
        <p>
            Therefore, we have completed the full mapping of our supply chain to our 4th tier private label
            manufacturing base, as follows:
        </p>
        <ul className="list">
            <li>1st Tier = Factory</li>
            <li>2nd Tier = Mill House</li>
            <li>3rd Tier = Dye House</li>
            <li>4th Tier = Print House</li>
        </ul>
        <p>
            More information on what the JD Group is doing to eradicate Modern Slavery within its supply chain can be
            found in its Modern Slavery Report.
        </p>
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/modern-slavery-report-2021.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="modern-slavery/modern-slavery.png" style={{ filter: 'invert(1)', width: '100px' }} />
                    JD Group Modern Slavery Report 2021/2022
                </a>
            </li>
        </ul>
        <Link to={content.link.url} title={content.link.text} className="fg-yellow">
            {content.link.text}
            <i />
        </Link>
        <div className="date-updated">Last Updated: {content.dateUpdated}</div>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/modern-slavery.jpg',
    body: Body,
    link: {
        url: '/world-transparency',
        text: 'Explore our Supply Chain',
    },
    dateUpdated: '05/01/2021 09:00GMT',
};
